import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web/common/consts/ISO_TO_COUNTRY_NAME";
export var getCountryName = function getCountryName(countryISO, strictLocalize) {
  return ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[countryISO];
};